import React, { useState } from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { LegalDocument, LegalModal } from './LegalModal';
import { LOGO_URL, PHONE_TEL, WHATSAPP_URL } from './data';
import { useLanguage } from './i18n/LanguageContext';
export function Footer() {
  const [activeDocument, setActiveDocument] = useState<LegalDocument | null>(null);
  const {
    t
  } = useLanguage();
  return <footer className="mt-16 border-t border-brand-border bg-[#faf0e7]" data-id="element-174" data-mp="3ueilfwsu32dg">
      <div className="max-w-2xl mx-auto px-6 py-12 text-center" data-id="element-175" data-mp="3ud7czjog16g0">
        <img src={LOGO_URL} alt={t.footer.logoAlt} className="h-52 sm:h-64 w-auto object-contain mx-auto mb-5 [mix-blend-mode:darken]" data-id="element-176" data-mp="387fbm8yvbf9" />

        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-6" data-id="element-177" data-mp="3qdf2h1fhoq80">
          {t.nav.map(link => <a key={link.href} href={link.href} className="font-body text-[10px] tracking-[2px] uppercase text-soft hover:text-gold transition-colors" data-id="element-178" data-mp="29yxdpewb9omv">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center justify-center gap-4 mb-7" data-id="element-179" data-mp="3labr7utqu4pu">
          <a href="https://www.instagram.com/gbstudiony/" aria-label="Instagram" className="w-10 h-10 rounded-full border border-champagne-deep/60 flex items-center justify-center text-champagne-deep hover:bg-champagne hover:text-dark transition-colors" data-id="element-180" data-mp="3gaz1n2bhmjjk">
            <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-181" data-mp="3qapz9cvchenv" />
          </a>
          <a href="https://www.facebook.com/GingerBrionesC5/?ref=PROFILE_EDIT_xav_ig_profile_page_web#" aria-label="Facebook" className="social-icon-elevation flex h-10 w-10 items-center justify-center rounded-full border border-champagne-deep/60 text-champagne-deep transition-colors hover:bg-champagne hover:text-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-182" data-mp="81foxu0vmo35">
            <Facebook className="w-4 h-4" strokeWidth={1.75} data-id="element-183" data-mp="mspndmmo4p4z" />
          </a>
        </div>

        <p className="font-body font-light text-soft text-sm leading-[1.7]" data-id="element-184" data-mp="tvmrhl25amnh">
          96-02 37th Ave, Corona, NY 11368
          <br data-id="element-185" data-mp="yv94puhz42wa" />
          {t.footer.whatsappLabel}&nbsp;
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="transition-colors hover:text-gold" data-id="element-186" data-mp="13tan0d7kry6p">
            (347) 888-6047
          </a>
          &nbsp;·&nbsp;{t.footer.callsLabel}&nbsp;
          <a href={`tel:${PHONE_TEL}`} className="transition-colors hover:text-gold" data-id="element-187" data-mp="1clmbhtj4pbk1">
            (347) 242-2967
          </a>
          <br data-id="element-188" data-mp="1hjw6o44usc5n" />
          {t.footer.hours}
          <br data-id="element-189" data-mp="1hiun1b9ruhcb" />
          {t.footer.reviewsLine}
        </p>

        <p className="font-serif italic text-gold text-sm mt-5" data-id="element-190" data-mp="1mktougpv5675">{t.footer.quote}</p>

        <div className="mt-7 flex items-center justify-center gap-4 font-body text-[10px] uppercase tracking-[2px] text-soft" data-id="element-191" data-mp="1rjeoof17dnv2">
          <button type="button" onClick={() => setActiveDocument('privacy')} className="transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-192" data-mp="3ocgh0llhr757">
            {t.footer.privacy}
          </button>
          <span aria-hidden="true" className="h-3 w-px bg-brand-border" data-id="element-193" data-mp="21mjzl59i3r66" />
          <button type="button" onClick={() => setActiveDocument('terms')} className="transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-194" data-mp="21kpb5gz0tgxc">
            {t.footer.terms}
          </button>
        </div>
        <p className="mt-2 font-body text-[10px] text-soft" data-id="element-195" data-mp="2kc00htp3lln4">{t.footer.effective}</p>
      </div>

      <LegalModal legalDocument={activeDocument} onClose={() => setActiveDocument(null)} data-id="element-196" data-mp="2fdf09u9uj1yo" />
    </footer>;
}